<template>
  <div class="dp_pk" ref="container">
    <div class="dp_pk_head">
      <img src="../../assets/images/pkback.jpg" class="dp_pk_headimg" />
      <div class="dp_pk_logo">
        <img src="../../assets/images/logo_white.png" />
      </div>
      <div class="dp_pk_ruleBtn">
        <router-link :to="'news_detail/2'">活动规则</router-link>
      </div>
      <div class="dp_flex_btns dp_pk_btns">
        <div class="dp_flex_btn dp_pk_btn">
          <router-link :to="''">
            <!-- <span class="iconfont icon-xiazai5"></span> -->
            全部PK
          </router-link>
        </div>
        <div class="dp_flex_btn dp_pk_btn">
          <router-link :to="'/user/pk/1'" class="pink">
            <!-- <span class="iconfont icon-xiazai5"></span> -->
            我参与的
          </router-link>
        </div>
        <div class="dp_flex_btn dp_pk_btn">
          <router-link :to="'/user/pk/pk_add'" class="pink">
            <!-- <span class="iconfont icon-xiazai5"></span> -->
            发起PK
          </router-link>
        </div>
      </div>
    </div>
    <div class="dp_pk_doing">
      <div class="dp_pk_list_item" v-for="pk in pkList_doing" :key="pk.id">
        <div class="dp_pk">
          <div class="dp_item dp_pk_item">
            <img :src="pk.s_avatar" />
            <div>{{ pk.s_nickname }}</div>
          </div>
          <div class="dp_item dp_vs">
            <img src="../../assets/images/vs1.png" />
          </div>
          <div class="dp_item dp_pk_item">
            <img :src="pk.r_avatar" />
            <div>{{ pk.r_nickname }}</div>
          </div>
        </div>
        <div class="dp_jindu">
          <div
            class="dp_jindu_l"
            :class="getLKing(pk)"
            :style="getLeftWidth(pk)"
          >
            {{ pk.s_salse }}
          </div>
          <div
            class="dp_jindu_r"
            :class="getRKing(pk)"
            :style="getRightWidth(pk)"
          >
            {{ pk.r_salse }}
          </div>
        </div>
      </div>
    </div>
    <div class="dp_pk_complete">
      <div class="dp_pk_complete_title">
        <img src="../../assets/images/pk_wangqi.jpg" />
      </div>
      <div class="dp_pk_complete_list">
        <div class="dp_pk_com_item" v-for="pk in pkList" :key="pk.id">
          <div class="dp_pk_com_title">
            {{ pk.s_nickname }} vs {{ pk.r_nickname }}
          </div>
          <div class="dp_pk_com_jindu">
            <div
              class="dp_pk_jindu_l"
              :class="getLKing(pk)"
              :style="getLeftWidth(pk)"
            >
              <span>￥{{ pk.s_salse }}</span
              ><img src="../../assets/images/shengfang.png" />
            </div>
            <div
              class="dp_pk_jindu_r"
              :class="getRKing(pk)"
              :style="getRightWidth(pk)"
            >
              <span>￥{{ pk.r_salse }}</span
              ><img src="../../assets/images/shengfang.png" />
            </div>
          </div>
          <div class="dp_pk_com_des">
            <span v-if="pk.status == 4"
              >胜方：{{ pk.win_nickname }}，获得筹码{{ pk.chip * 2 }},系统奖励{{
                pk.dp_jifen_pk
              }}积分</span
            >
          </div>
        </div>
      </div>
      <div class="dp_height"></div>
    </div>
    <div class="noCart" v-if="pkList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noRecords.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getPkData, getPkList } from "@api/user";
import { cancelPkHandle, acceptPkHandle } from "@libs/pk";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
//const STATUS = ["全部", "我发起", "我收到", "PK中", "已完成"];
const NAME = "Pk";
export default {
  name: NAME,
  data() {
    return {
      pkData: {},
      type: parseInt(this.$route.params.type) || 5, //标签切换0-全部，1-我发起的，2-我接受的，3-pk中，4-已完成
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      pkList: [],
      pkList_doing: []
    };
  },
  components: {
    Loading
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    getLKing(pk) {
      //获取左侧是否是winner
      if (pk.win_uid == pk.s_uid) {
        return "dp_pk_m";
      }
    },
    getRKing(pk) {
      if (pk.win_uid == pk.r_uid) {
        return "dp_pk_m";
      }
    },
    getLWidth(pk) {
      var lwidth;
      if (pk.s_salse == 0 && pk.r_salse == 0) {
        return 0;
      }
      console.log(pk.id + "-" + pk.r_salse + "," + pk.s_salse);
      lwidth =
        (parseInt(pk.s_salse) / (parseInt(pk.r_salse) + parseInt(pk.s_salse))) *
        100;
      console.log(lwidth);
      lwidth = lwidth.toFixed(2);
      return lwidth;
    },
    getLeftWidth(pk) {
      var lwidth = this.getLWidth(pk);
      return { width: lwidth + "%" };
    },
    getRightWidth(pk) {
      var lwidth = this.getLWidth(pk);
      var rwidth = 100 - lwidth;
      return { width: rwidth + "%" };
    },
    getChiptype(chip_type) {
      return chip_type == 0 ? "积分" : "金额";
    },
    getChip(pk) {
      var re = "";
      if (pk.chip_type == 0) {
        re = pk.chip + " 积分";
      } else {
        re = "￥ " + pk.chip + " 元";
      }
      return re;
    },
    getPkData() {
      getPkData().then(res => {
        this.pkData = res.data;
      });
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.pkList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getPkList({
        page,
        limit,
        type
      }).then(res => {
        this.pkList = this.pkList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    getOrderList_doing() {
      var type = 6;
      var limit = 50;
      var page = 0;
      getPkList({
        page,
        limit,
        type
      }).then(res => {
        this.pkList_doing = res.data;
      });
    },
    delPk(pk) {
      cancelPkHandle(pk.id)
        .then(() => {
          this.pkList.splice(this.pkList.indexOf(pk), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    acceptTap: function(pk) {
      //接受PK
      acceptPkHandle(pk.id)
        .then(() => {
          this.pkList.splice(this.pkList.indexOf(pk), 1);
        })
        .catch(() => {
          this.reload();
        });
    }
  },
  mounted() {
    //this.getPkData();
    this.getOrderList();
    this.getOrderList_doing();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>
<style scoped>
.dp_height {
  height: 1rem;
}
</style>
